var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_812_10967)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.5 4.5C-0.5 3.70435 -0.183929 2.94129 0.37868 2.37868C0.941289 1.81607 1.70435 1.5 2.5 1.5H20.5C21.2956 1.5 22.0587 1.81607 22.6213 2.37868C23.1839 2.94129 23.5 3.70435 23.5 4.5V19.5C23.5 20.2956 23.1839 21.0587 22.6213 21.6213C22.0587 22.1839 21.2956 22.5 20.5 22.5H2.5C1.70435 22.5 0.941289 22.1839 0.37868 21.6213C-0.183929 21.0587 -0.5 20.2956 -0.5 19.5V4.5V4.5ZM1 18L4.969 14.469C5.0916 14.3468 5.25267 14.2709 5.42491 14.2539C5.59714 14.237 5.76994 14.2801 5.914 14.376L9.904 17.0355L15.469 11.4705C15.5802 11.3592 15.7237 11.2856 15.879 11.2603C16.0343 11.235 16.1937 11.2592 16.3345 11.3295L22 14.25V19.5C22 19.8978 21.842 20.2794 21.5607 20.5607C21.2794 20.842 20.8978 21 20.5 21H2.5C2.10218 21 1.72064 20.842 1.43934 20.5607C1.15804 20.2794 1 19.8978 1 19.5V18V18ZM8.5 8.25C8.5 8.84674 8.26295 9.41903 7.84099 9.84099C7.41903 10.2629 6.84674 10.5 6.25 10.5C5.65326 10.5 5.08097 10.2629 4.65901 9.84099C4.23705 9.41903 4 8.84674 4 8.25C4 7.65326 4.23705 7.08097 4.65901 6.65901C5.08097 6.23705 5.65326 6 6.25 6C6.84674 6 7.41903 6.23705 7.84099 6.65901C8.26295 7.08097 8.5 7.65326 8.5 8.25V8.25Z",
    fill: "#0D0D0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_812_10967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadLogo);
export default __webpack_public_path__ + "static/media/uploadLogo.badf659bf433f1692826f6a6af74d482.svg";
export { ForwardRef as ReactComponent };